/* eslint-disable react/no-unused-prop-types */
import React from 'react';

import { ClickAwayListener, MenuList, MenuItem } from '@mui/material';

import { IInboundInvoice } from 'commons/types';

import { RowMenuItemConfig } from '../configs';

export const ActionBtnMenuInboundInvoice: React.FC<{
  selectedInvoices: IInboundInvoice[];
  handleCloseMenu: () => void;
  handleOpen: (name: string) => void;
}> = (params) => {
  const {
    selectedInvoices,
    handleCloseMenu,
    handleOpen,
  }: {
    selectedInvoices: IInboundInvoice[];
    handleCloseMenu: () => void;
    handleOpen: (name: string) => void;
  } = params;

  return (
    <ClickAwayListener onClickAway={handleCloseMenu}>
      <MenuList id="split-button-menu" autoFocusItem>
        {RowMenuItemConfig.map((config) => (
          <MenuItem
            onClick={() => handleOpen(config.name)}
            disabled={config.disabled(selectedInvoices)}
            key={`menu-item-${config.name}`}
          >
            {config.name}
          </MenuItem>
        ))}
      </MenuList>
    </ClickAwayListener>
  );
};
